// class MediaSingleton {
//     constructor() {
//         if (!MediaSingleton.instance) {
//             this.currentAudioRef = null
//             this.subscribers = []
//             this.currentAudioInstanceId = null // Agregar esta línea
//             MediaSingleton.instance = this
//         }
//         return MediaSingleton.instance
//     }

//     static getInstance() {
//         if (!MediaSingleton.instance) {
//             MediaSingleton.instance = new MediaSingleton()
//         }
//         return MediaSingleton.instance
//     }

//     setCurrentAudioRef(audioRef, instanceId) {
//         if (this.currentAudioRef && this.currentAudioRef !== audioRef) {
//             try {
//                 this.currentAudioRef.pauseAsync()
//                 this.currentAudioRef.setPositionAsync(0)
//             } catch (error) {
//                 console.error('Error pausing audio:', error)
//             }
//         }
//         this.currentAudioInstanceId = instanceId // Agregar esta línea
//         this.currentAudioRef = audioRef
//         this.notifySubscribers()
//     }

//     setCurrentVideoRef(videoRef, instanceId) {
//         this.currentAudioRef = videoRef

//         this.currentAudioInstanceId = instanceId // Agregar esta línea
//         this.notifySubscribers()
//     }

//     getCurrentAudioRef() {
//         return this.currentAudioRef
//     }

//     playCurrentAudio() {
//         if (this.currentAudioRef) {
//             try {
//                 this.currentAudioRef.playAsync()
//             } catch (error) {
//                 console.error('Error playing audio:', error)
//             }
//         } else {
//             console.warn('No current audio reference set.')
//         }
//     }

//     playCurrentAudioById(instanceId) {
//         if (instanceId !== null && this.currentAudioRef !== null) {
//             this.currentAudioInstanceId = instanceId

//             if (this.currentAudioRef.toString() !== this.currentAudioInstanceId.toString()) {
//                 try {
//                     this.currentAudioRef.playAsync()
//                     this.notifySubscribers()
//                 } catch (error) {
//                     console.error('Error playing audio:', error)
//                 }
//             } else {
//                 console.warn('El audio no es igual al instanceId')
//             }
//         }
//     }
//     pauseCurrentAudio() {
//         if (this.currentAudioRef) {
//             try {
//                 this.currentAudioRef.pauseAsync()
//                 this.notifySubscribers()
//             } catch (error) {
//                 console.error('Error pausing audio:', error)
//             }
//         } else {
//             console.warn('No current audio reference set.')
//         }
//     }

//     pauseCurrentAudioById(instanceId) {
//         if (instanceId !== null && this.currentAudioRef !== null) {
//             this.currentAudioInstanceId = instanceId

//             if (this.currentAudioRef.toString() !== this.currentAudioInstanceId.toString()) {
//                 try {
//                     this.currentAudioRef.pauseAsync()
//                     this.notifySubscribers()
//                 } catch (error) {
//                     console.error('Error pausing audio:', error)
//                 }
//             } else {
//                 console.warn('El audio no es igual al instanceId')
//             }
//         }
//     }

//     getCurrentAudioInstanceId() {
//         // Agregar esta función
//         return this.currentAudioInstanceId
//     }

//     subscribe(callback) {
//         this.subscribers.push(callback)
//     }

//     unsubscribe(callback) {
//         this.subscribers = this.subscribers.filter((subscriber) => subscriber !== callback)
//     }

//     notifySubscribers() {
//         this.subscribers.forEach((callback) => callback(this.currentAudioInstanceId))
//     }
// }

// export default MediaSingleton.getInstance()


class MediaSingleton {
    constructor() {
        // Video players por postId
        this.videoPlayers = {} // { postId: videoRef }
        // Audio players por postId (podcasts)
        this.audioPlayers = {} // { postId: audioRef }
        // Compatibilidad con APIs existentes en PodcastView
        this.currentAudioRef = null
        this.currentAudioInstanceId = null
        this.subscribers = []
    this.videoSubscribers = []
        // Estado actual de vídeo (opcional)
        this.currentVideoRef = null
        this.currentVideoInstanceId = null
    }

    // Suscripciones (compat con PodcastView)
    subscribe(callback) {
        if (typeof callback === 'function') this.subscribers.push(callback)
    }
    unsubscribe(callback) {
        this.subscribers = this.subscribers.filter((cb) => cb !== callback)
    }
    notifySubscribers() {
        this.subscribers.forEach((cb) => {
            try { cb(this.currentAudioInstanceId) } catch {}
        })
    }
    // Suscripciones específicas de VIDEO
    subscribeVideo(callback) {
        if (typeof callback === 'function') this.videoSubscribers.push(callback)
    }
    unsubscribeVideo(callback) {
        this.videoSubscribers = this.videoSubscribers.filter((cb) => cb !== callback)
    }
    notifyVideoSubscribers(postId) {
        this.videoSubscribers.forEach((cb) => {
            try { cb(postId) } catch {}
        })
    }

    // Registro de VIDEO (compat con VideoPlayerAV.registerPlayer)
    registerPlayer(postId, videoRef) { this.registerVideo(postId, videoRef) }
    registerVideo(postId, videoRef) {
        this.videoPlayers[postId] = videoRef
    }
    unregisterPlayer(postId) { this.unregisterVideo(postId) }
    unregisterVideo(postId) {
        try { delete this.videoPlayers[postId] } catch {}
        if (this.currentVideoInstanceId === postId) {
            this.currentVideoInstanceId = null
            this.currentVideoRef = null
        }
    }
    setCurrentVideoRef(videoRef, instanceId) {
        this.currentVideoRef = videoRef
        this.currentVideoInstanceId = instanceId
        this.registerVideo(instanceId, videoRef)
        // No notificamos subs de audio aquí; la exclusividad se dispara en notifyPlaying
        // Pero sí notificamos a subs de VIDEO para sincronizar UIs como ReelsViewer
        this.notifyVideoSubscribers(instanceId)
    }

    // Registro de AUDIO (compat con PodcastView)
    registerAudio(postId, audioRef) {
        this.audioPlayers[postId] = audioRef
    }
    unregisterAudio(postId) {
        try { delete this.audioPlayers[postId] } catch {}
        if (this.currentAudioInstanceId === postId) {
            this.currentAudioInstanceId = null
            this.currentAudioRef = null
            this.notifySubscribers()
        }
    }
    setCurrentAudioRef(audioRef, instanceId) {
        // Pausar audio anterior si existe
        if (this.currentAudioRef && this.currentAudioRef !== audioRef) {
            try { this.currentAudioRef.pauseAsync?.() } catch {}
        }
        this.currentAudioRef = audioRef
        this.currentAudioInstanceId = instanceId
        this.registerAudio(instanceId, audioRef)
        // Exclusividad: al activar un audio, pausar videos y otros audios
        this.pauseAllExcept(instanceId)
        this.notifySubscribers()
    }
    getCurrentAudioRef() { return this.currentAudioRef }
    getCurrentAudioInstanceId() { return this.currentAudioInstanceId }
    playCurrentAudio() { try { this.currentAudioRef?.playAsync?.() } catch {} }
    pauseCurrentAudio() { try { this.currentAudioRef?.pauseAsync?.() } catch {} }
    playCurrentAudioById(postId) {
        // Reutilizamos también para VIDEO (API histórica mal nombrada)
        // 1) Pausar todos menos el solicitado
        this.pauseAllExcept(postId)
        // 2) Intentar reproducir video con ese ID
        const vRef = this.videoPlayers[postId]
        if (vRef?.playAsync) {
            try { vRef.playAsync() } catch {}
        }
        // 3) Intentar reproducir audio con ese ID si aplica
        const aRef = this.audioPlayers[postId]
        if (aRef?.playAsync) {
            try {
                aRef.playAsync()
                this.currentAudioRef = aRef
                this.currentAudioInstanceId = postId
                this.notifySubscribers()
            } catch {}
        }
    }
    pauseCurrentAudioById(postId) {
        const aRef = this.audioPlayers[postId]
        if (aRef?.pauseAsync) { try { aRef.pauseAsync() } catch {} }
        const vRef = this.videoPlayers[postId]
        if (vRef?.pauseAsync) { try { vRef.pauseAsync() } catch {} }
    }

    pauseAllAudios() {
        Object.values(this.audioPlayers).forEach((ref) => { try { ref?.pauseAsync?.() } catch {} })
    }
    pauseAllVideos() {
        Object.values(this.videoPlayers).forEach((ref) => { try { ref?.pauseAsync?.() } catch {} })
    }
    pauseAllExcept(postId) {
        Object.entries(this.videoPlayers).forEach(([id, ref]) => {
            if (id !== String(postId)) { try { ref?.pauseAsync?.() } catch {} }
        })
        Object.entries(this.audioPlayers).forEach(([id, ref]) => {
            if (id !== String(postId)) { try { ref?.pauseAsync?.() } catch {} }
        })
    }

    // Notificar que un player (audio o video) empezó a reproducir
    notifyPlaying(postId) {
        // Pausar todos los demás
        this.pauseAllExcept(postId)
        // Si era un video, marcamos audio como no-actual para forzar update en PodcastView
        if (this.currentAudioInstanceId !== null && this.currentAudioInstanceId !== postId) {
            this.currentAudioInstanceId = postId // forzamos un valor distinto al de cada PodcastView
            this.notifySubscribers()
        }
        // Notificar también a subs de VIDEO
        this.notifyVideoSubscribers(postId)
    }
}

const mediaSingleton = new MediaSingleton()
export default mediaSingleton
